<template>
  <a-card :bordered="false">
    <a-form-model
      :label-col="{span:4}"
      :wrapper-col="{span:20}"
      ref="form"
      :model="taskForm"
      :rules="taskRules"
    >
      <a-form-model-item
        label="关联商品"
        prop="proId"
      >
        <a-button :disabled="disableShow" type="primary" style="margin-right: 20px" @click="toSelectEvent(1)">关联
        </a-button>
        <span>商品ID：{{ taskForm.proId ? taskForm.proId : '--' }}</span>
      </a-form-model-item>
      <a-form-model-item label="标题" prop="title">
        <a-input :disabled="disableShow" v-model="taskForm.title" :maxLength="120" placeholder="请输入"
                 style="max-width: 400px"/>
      </a-form-model-item>
      <a-form-model-item label="副标题">
        <a-input :disabled="disableShow" v-model="taskForm.subtitle" :maxLength="20" placeholder="请输入"
                 style="max-width: 400px"/>
      </a-form-model-item>
      <a-form-model-item label="上传封面" prop="coverImage">
        <custom-upload-pro-images
          v-model="taskForm.coverImage"
          :multiple-selected="true"
          :draggableUpdate="false"
          :showFlag="false"
          :showDelete="true"
          :isDeleteLocal="true"
          :disabled="disableShow"
          :maxCount="1"
          :tips="tips">
        </custom-upload-pro-images>
      </a-form-model-item>
      <a-form-model-item
        label="任务类型"
        :required="true" prop="taskType">
        <a-form-model-item></a-form-model-item>
        <a-radio-group v-model="taskForm.taskType" :disabled="disableShow" @change="onRadioChange">
          <a-radio
            v-for="(item,index) in taskForm.options"
            :value="item.type"
            style="line-height: 60px;"
            :key="item.type">
            <div style="display: inline-block;width: 120px;">{{ item.name }}</div>
            <a-form-model-item
              style="display: inline-block;margin-bottom: 0;"
              :prop="'options.'+index+'.value'"
              :rules="taskRules['options.value']"
            >
              <span>{{ item.secondTitle }}</span>
              <a-input
                v-model="item.value"
                style="width: 160px"
                @change="onInputChange"
                :disabled="taskForm.taskType!==item.type||disableShow"
                type="number"><span
                slot="addonAfter">{{ item.unitName }}</span></a-input>
            </a-form-model-item>
            <a-form-model-item
              style="display: inline-block;margin-bottom: 0"
              :prop="'options.'+index+'.reward'"
              :rules="taskRules['options.reward']"
            >
              <span>获得</span>
              <a-input
                @change="onInputChange"
                :disabled="taskForm.taskType!==item.type||disableShow"
                v-model="item.reward"
                style="width: 160px"
                type="number"><span slot="addonAfter">元</span></a-input>
            </a-form-model-item>
          </a-radio>
        </a-radio-group>

      </a-form-model-item>
      <a-form-model-item label="领取任务后" prop="receiveValidDays">
        <a-input style="width: 400px" :disabled="disableShow" v-model="taskForm.receiveValidDays" type="number"><span
          slot="addonAfter">天内，完成有效</span></a-input>
      </a-form-model-item>
      <a-form-model-item label="可领任务时间" prop="selectedDate">
        <a-range-picker
          name="buildTime"
          :disabled="disableShow"
          style="width: 400px"
          :value="taskForm.selectedDate"
          format="YYYY-MM-DD"
          :allowClear="false"
          :disabledDate="disabledDate"
          @change="onDateChange"
        />
      </a-form-model-item>
      <a-form-model-item
        label="指定分组参与"
      >
        <a-tag
          v-for="(item ,index) in taskForm.groupIdsList"
          :key="item"
          :style="{'margin-left': index===0?0:10+'px'}"
          :closable="!disableShow" @close="() => handleCloseTasEvent(item,index,1)"
        >
          <span>分组ID：</span>
          {{ item }}
        </a-tag>
        <a-button :disabled="disableShow" type="primary" style="margin-left: 20px" @click="toSelectEvent(2)">添加
        </a-button>
      </a-form-model-item>
      <a-form-model-item
        label="黑名单分组"
      >
        <a-tag
          v-for="(item ,index) in taskForm.blackGroupIdsList"
          :key="item"
          :style="{'margin-left': index===0?0:10+'px'}"
          :closable="!disableShow" @close="() => handleCloseTasEvent(item,index,2)"
        >
          <span>分组ID：</span>
          {{ item }}
        </a-tag>
        <a-button :disabled="disableShow" type="primary" style="margin-left: 20px" @click="toSelectEvent(3)">添加
        </a-button>
      </a-form-model-item>
      <a-form-model-item
        label="任务说明"
        :required="true"
        prop="remark">
        <a-textarea
          v-model="taskForm.remark"
          :disabled="disableShow"
          :rows="4"
          placeholder="请输入"
          :max-length="200"
        ></a-textarea>
      </a-form-model-item>
      <a-form-model-item
        label="  "
        :colon="false"
        :required="false"
      >
        <a-button type="primary" @click="saveEvent" :loading="saveLoading" :disabled="disableShow">保存</a-button>
        <a-button style="margin-left: 20px" @click="backEvent">取消</a-button>
      </a-form-model-item>
    </a-form-model>
    <selected-product-dialog
      :show="showSelectedDialog"
      title="关联商品"
      ref="pageList"
      :itemNames="['search_proId','search_proName']"
      :query-params="openType==1?selectedQueryParams:queryParams"
      :requestPromise="openType==1?null:loadPromise1"
      :params-path="openType==1?'public/getGoodsList':''"
      :base-key="openType==1?'proUrl':''"
      @close="showSelectedDialog=false"
      :columns="openType==1?goodsColumns:groupColumns"
    >
      <template v-if="openType==1">
        <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
          <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入"></a-input>
        </a-form-item>
        <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
          <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入"></a-input>
        </a-form-item>
      </template>
      <template v-else>
        <a-form-item label="分组ID" slot="search_proId" v-bind="currentDialogLayout">
          <a-input v-model="queryParams.groupId" style="width: 170px" placeholder="请输入"></a-input>
        </a-form-item>
        <a-form-item label="分组名称" slot="search_proName" v-bind="currentDialogLayout">
          <a-input v-model="queryParams.groupName" style="width: 170px" placeholder="请输入"></a-input>
        </a-form-item>
      </template>

      <template slot="proTypeSlot" slot-scope="rowItem">{{ rowItem.text|productTypeName }}</template>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
//营销任务 编辑器（创建、编辑）
import salesTaskMixins from '@/views/service/serviceProvider/salesTask/salesTaskMixins'
import CustomUploadProImages from '@/customComponents/CustomUploadProImages/CustomUploadProImages'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import searchForm from '@/utils/mixins/searchFormMixins'
import formMixin from '@/utils/mixins/formMixins'
import moment from 'moment'

const taskOptions = [
  {
    type: 1,
    name: '收藏',
    secondTitle: '累计收藏',
    unitName: '用户',
    reward: '',
    value: ''
  },
  {
    type: 2,
    name: '商品浏览量',
    secondTitle: '累计浏览',
    unitName: '用户',
    reward: '',
    value: ''
  },
  {
    type: 3,
    name: '下单金额',
    secondTitle: '累计下单',
    unitName: '元',
    reward: '',
    value: ''
  },
  {
    type: 4,
    name: '下单数量',
    secondTitle: '累计下单',
    unitName: '用户',
    reward: '',
    value: ''
  }
]
export default {
  name: 'TaskEditor',
  mixins: [searchForm, formMixin, salesTaskMixins],
  components: {
    CustomUploadProImages,
    SelectedProductDialog
  },

  data() {
    return {
      tips: '温馨提示：建议图片长宽比为1:1，图片大小在800px*800px以上，格式.jpg、.png、.jpeg',
      taskId: this.$route.query.taskId,
      disableShow: this.$route.query.disableType ? true : false,
      openType: 1,
      saveLoading: false,
      initFinish: false,
      showSelectedDialog: false,
      selectedQueryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        shelfStatus: 1
      },
      queryParams: {
        groupTaskType: 1,
        settingId: '',
        groupId: '',
        groupName: ''
      },
      taskForm: {
        taskType: 1,//1 是收藏 2是浏览 3是下单金额 4是下单数量
        coverImage: undefined,
        proId: undefined,
        title: undefined,
        selectedDate: undefined,
        subtitle: '',
        totalCount: '',
        totalOrderMoney: '',
        packageMoney: undefined,
        receiveValidDays: undefined,
        validStartTime: '',
        validEndTime: '',
        remark: undefined,
        blackGroupIdsList: [],
        groupIdsList: [],
        options: [
          {
            type: 1,
            name: '收藏',
            secondTitle: '累计收藏',
            unitName: '用户',
            reward: '',
            value: ''
          },
          {
            type: 2,
            name: '商品浏览量',
            secondTitle: '累计浏览',
            unitName: '用户',
            reward: '',
            value: ''
          },
          {
            type: 3,
            name: '下单金额',
            secondTitle: '累计下单',
            unitName: '元',
            reward: '',
            value: ''
          },
          {
            type: 4,
            name: '下单数量',
            secondTitle: '累计下单',
            unitName: '用户',
            reward: '',
            value: ''
          }
        ]
      },
      taskRules: {
        'options.value': [
          { validator: this.validatorOptionsValue, trigger: ['blur', 'change'] }
        ],
        'options.reward': [
          { validator: this.validatorOptionsReward, trigger: ['blur', 'change'] }
        ],
        title: [
          { required: true, message: '请输入标题', trigger: ['blur', 'change'] }
        ],
        proId: [
          { required: true, message: '请关联商品', trigger: ['blur', 'change'] }
        ],
        coverImage: [
          { required: true, message: '请上传封面图片', trigger: ['blur', 'change'] }
        ],
        selectedDate: [
          { required: true, type: 'array', message: '请输入可领任务时间', trigger: ['blur', 'change'] }
        ],
        receiveValidDays: [
          { required: true, message: '请输入领取任务有效期', trigger: ['blur', 'change'] },
          {
            required: true,
            pattern: new RegExp(/^[1-9]\d*$/, 'g'),
            message: '请输入正确的天数'
          }
        ],
        taskType: [
          { required: true, message: '请选择任务类型', trigger: ['blur', 'change'] }
        ],
        remark: [
          { required: true, message: '请输入任务说明', trigger: ['blur', 'change'] }
        ]
      },
      goodsColumns: [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '300px'
        },
        {
          title: '商品分类',
          dataIndex: 'proType',
          scopedSlots: { customRender: 'proTypeSlot' },
          width: '100px'
        },
        {
          title: '操作',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          dataIndex: 'action',
          fixed: 'right'
        }
      ],
      groupColumns: [
        {
          title: '分组ID',
          dataIndex: 'groupId',
          width: '100px'
        },
        {
          title: '分组名称',
          dataIndex: 'groupName',
          width: '300px'
        },
        {
          title: '成员数',
          dataIndex: 'staffNumber'
        },
        {
          title: '操作',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          dataIndex: 'action',
          fixed: 'right'
        }
      ],
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      loadPromise: params => this.getListPromise(params),
      loadPromise1: params => this.getSettingGroupsPromise(params)
    }
  },
  watch: {
    'taskForm.taskType': function(newVal, oldVal) {
      this.$refs['form'].validate(valid => {
      })
    }
  },
  mounted() {
    // this.taskForm.options = taskOptions.map(item => {
    //   return { ...item }
    // })
    this.initFinish = true
    if (this.taskId) {
      this.getDetail()
    }
  },
  methods: {
    moment,
    onInputChange() {
      this.$refs['form'].validate(valid => {
      })
    },
    disabledDate(current) {
      let days = moment().endOf('day').valueOf()
      return current.valueOf() < days - 3600000 * 24
    },
    getDetail() {
      this.getHttpServices().getUserService().get('staff/marketTask/getSettingById/' + this.taskId)
        .then(res => {
          this.taskForm.proId = res.proId
          this.taskForm.title = res.title
          this.taskForm.subtitle = res.subtitle
          this.taskForm.taskType = res.taskType
          this.taskForm.proName = res.proName
          this.taskForm.receiveValidDays = res.receiveValidDays
          this.taskForm.remark = res.remark
          this.taskForm.groupIdsList = res.groupIdsList
          this.taskForm.blackGroupIdsList = res.blackGroupIdsList
          this.taskForm.coverImage = [res.coverImage]
          this.taskForm.validStartTime = res.validStartTime
          this.taskForm.validEndTime = res.validEndTime
          let index = res.taskType - 1
          if (this.taskForm.options && this.taskForm.options.length > 0) {
            this.taskForm.options.forEach(item => {
              item.reward = undefined
              item.value = undefined
            })
          }
          this.taskForm.options[index].value = res.taskType == 3 ? res.totalOrderMoney : res.totalCount
          this.taskForm.options[index].reward = res.packageMoney
          this.taskForm.selectedDate = this.getDateHelper().getDateMoments(res.validStartTime, res.validEndTime)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onRadioChange(e) {
      this.getLogUtils().logWithTag('radio checked', e.target.value)
      if (this.taskForm.options && this.taskForm.options.length > 0) {
        this.taskForm.options.forEach(item => {
          item.reward = undefined
          item.value = undefined
        })
      }
    },
    getSettingGroupsPromise(params) {
      return this.getHttpServices().getUserService().post('merchant/v2/clock/getSettingGroups', params)
    },
    getListPromise(params) {
      return this.getHttpServices().getProService().post('api/v2/productManage/findProductList', params)
    },
    //日期变更
    onDateChange(dates, dateStrArr) {
      this.taskForm.validStartTime = dateStrArr[0]//开始时间
      this.taskForm.validEndTime = dateStrArr[1]//结束时间
      let selectedDates = this.getDateHelper().getDateMoments(dateStrArr[0], dateStrArr[1])
      this.taskForm.selectedDate = selectedDates
      this.taskForm = {
        ...this.taskForm
      }
    },
    // 选择商品
    onSelectedResult(data) {
      if (this.openType == 1) {
        this.taskForm.proId = data.proId
        this.taskForm.proName = data.proName
        this.taskForm.title = this.taskForm.title ? this.taskForm.title : data.proName
        this.getProductImg(data.proId)
      } else if (this.openType == 2) {
        if (this.taskForm.groupIdsList.findIndex(item => item === data.groupId) > -1) {
          this.$message.error('请勿重复添加分组')
        } else {
          this.taskForm.groupIdsList.push(data.groupId)
        }
      } else {
        if (this.taskForm.blackGroupIdsList.findIndex(item => item === data.groupId) > -1) {
          this.$message.error('请勿重复添加分组')
        } else {
          this.taskForm.blackGroupIdsList.push(data.groupId)
        }
      }
      this.showSelectedDialog = false
    },
    getProductImg(id) {
      this.getHttpServices().getProService().get('product/info/getProInfo/' + id)
        .then(res => {
          this.taskForm.coverImage = this.taskForm.coverImage ? this.taskForm.coverImage : [res.proImg]
          this.getLogUtils().logWithTag('this.taskForm', this.taskForm)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    validatorOptionsValue(rule, value, callback) {
      let splits = rule.fullField.split('.')
      let optionItem = this.taskForm.options[splits[1]]
      if (optionItem.type === this.taskForm.taskType) {
        if (this.taskForm.taskType === 3) {
          this.validatorMoney(value, callback)
        } else {
          this.validatorNumber(value, callback)
        }
      } else {
        callback()
      }
    },
    validatorOptionsReward(rule, value, callback) {
      let splits = rule.fullField.split('.')
      if (this.taskForm.options[splits[1]].type === this.taskForm.taskType) {
        this.validatorMoney(value, callback)
      } else {
        callback()
      }
    },
    validatorNumber(value, callback) {
      if (value === 0) {
        callback(new Error('数量必须大于0'))
      } else if (!value) {
        callback(new Error('请输入数量'))
      } else if (/^[1-9][0-9]*$/.test(value)) {
        callback()
      } else {
        callback(new Error('数量只能为正整数'))
      }
    },
    validatorMoney(value, callback) {
      if (value === 0) {
        callback(new Error('金额必须大于0'))
      } else if (!value) {
        callback(new Error('请输入金额'))
      } else if (/^(?!0+$)(?!0*\.0*$)\d{1,8}(\.\d{1,2})?$/.test(value)) {
        callback()
      } else {
        callback(new Error('金额只能为整数或包含两位小数'))
      }
    },
    /**
     * 标签关闭
     * @param item
     * @param index
     * @param type 1表示参与成员分组 2表示黑名单分组
     */
    handleCloseTasEvent(item, index, type) {
      if (!this.disableShow) {
        let list = type === 1 ? [...this.taskForm.groupIdsList] : [...this.taskForm.blackGroupIdsList]
        if (list.length > 0) {
          list = list.filter((item, fIndex) => fIndex !== index)
        }
        if (type === 1) {
          this.taskForm.groupIdsList = list
        } else {
          this.taskForm.blackGroupIdsList = list
        }
      }
    },
    toSelectEvent(type) {
      this.openType = type
      this.showSelectedDialog = true
      this.$nextTick(() => {
        this.$refs.pageList.refresh(true)
      })
    },
    saveEvent() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.submitForm()
        }
      })
    },
    submitForm() {
      let params = {
        id: this.taskId ? this.taskId : '',
        proId: this.taskForm.proId,
        title: this.taskForm.title,
        subtitle: this.taskForm.subtitle,
        coverImage: this.taskForm.coverImage[0],
        taskType: this.taskForm.taskType,
        totalCount: this.taskForm.taskType !== 3 ? this.taskForm.options[this.taskForm.taskType - 1].value : '',
        totalOrderMoney: this.taskForm.taskType == 3 ? this.taskForm.options[this.taskForm.taskType - 1].value : '',
        packageMoney: this.taskForm.options[this.taskForm.taskType - 1].reward,
        proName: this.taskForm.proName,
        receiveValidDays: this.taskForm.receiveValidDays,
        validStartTime: this.taskForm.validStartTime,
        validEndTime: this.taskForm.validEndTime,
        remark: this.taskForm.remark,
        groupIdsList: this.taskForm.groupIdsList,
        blackGroupIdsList: this.taskForm.blackGroupIdsList,
        merchantId: this.$store.getters.userInfo.merchantId
      }
      this.getHttpServices().getUserService().post('staff/marketTask/saveSetting', params)
        .then(res => {
          this.$message.success('保存成功')
          this.$router.go(-1)
          this.getLogUtils().logWithTag('submitForm', res)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style scoped lang="less">
.custom-form-model-item {
  line-height: 60px;
  display: inline-block
}
</style>